import {Box} from '@wix/design-system'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Tabs, TabsAlignment} from 'wix-ui-tpa/cssVars'
import {ALL_CATEGORIES_FILTER} from '../../../../../commons/constants/settings'
import {isCategoryMenuMode} from '../../../../../commons/selectors/categories'
import {useSettings} from '../../../hooks/use-settings'
import {useWidgetActions, useWidgetState} from '../../hooks/state-provider'
import {getCategoryTabItems} from '../../selectors/categories'
import {getVeloCategoryId} from '../../selectors/velo-overrides'
import {classes} from './category-tabs.st.css'
import {CategoryTabsProps} from './interfaces'

export const CategoryTabs = ({marginBottom = 4}: CategoryTabsProps) => {
  const {t} = useTranslation()
  const {get: getSetting} = useSettings()
  const actions = useWidgetActions()
  const tabItems = useWidgetState(state => getCategoryTabItems(state, getSetting, t))
  const selectedCategoryId = useWidgetState(getVeloCategoryId)

  const showCategoryMenu = isCategoryMenuMode(getSetting)

  const targetId = selectedCategoryId === null ? ALL_CATEGORIES_FILTER : selectedCategoryId
  const currentTabIndex = tabItems.findIndex(item => item.id === targetId)
  const activeTabIndex = currentTabIndex >= 0 ? currentTabIndex : undefined

  const handleTabClick = (newTabIndex: number) => {
    const newCategoryId = tabItems[newTabIndex].id
    const veloCategoryId = newCategoryId === ALL_CATEGORIES_FILTER ? null : newCategoryId
    actions.selectCategory(veloCategoryId)
  }

  if (!showCategoryMenu) {
    return null
  }

  return (
    <Box marginBottom={marginBottom}>
      <Tabs
        items={tabItems}
        activeTabIndex={activeTabIndex}
        onTabClick={handleTabClick}
        alignment={TabsAlignment.left}
        className={classes.root}
      />
    </Box>
  )
}
